<template>
  <a-modal v-model="visible" :maskClosable="false" title="项目做单" width="96vw" @ok="handleOk" :destroyOnClose="true"
    :dialogStyle="{ minWidth: '1440px', maxWidth: '1920px' }">
    <a-row>
      <a-col :span="24">
        <a-descriptions class="mb-20" :column="4">
          <div slot="title">
            行程名称： {{ tripInfo.trip_name }}
          </div>
          <a-descriptions-item label="客户姓名">
            {{ tripInfo.customerinfo && tripInfo.customerinfo.customer_name ? tripInfo.customerinfo.customer_name : ''
            }}
          </a-descriptions-item>
          <a-descriptions-item label="行程人数">
            <a-statistic :value="tripInfo.person_length"
              :suffix="'人 ' + (tripInfo.trip_relationship ? `(${tripInfo.trip_relationship})` : '')" class="ml-20" />
          </a-descriptions-item>
          <a-descriptions-item label="行程日期">
            <a-tag v-for="v in tripInfo.trip_days.split(',')">{{ v }}</a-tag>
          </a-descriptions-item>
          <!-- <a-descriptions-item label="行程结束日期">
        {{ tripInfo.trip_end.substring(0, 10) }}
      </a-descriptions-item> -->
          <a-descriptions-item label="行程订单时间">
            {{ tripInfo.trip_createtime }}
          </a-descriptions-item>
          <!-- <a-descriptions-item>
      </a-descriptions-item> -->
          <a-descriptions-item label="vip级别">
            <div
              v-if="tripInfo.customerinfo && tripInfo.customerinfo.memberChildren && tripInfo.customerinfo.memberChildren.length > 0">
              <a-tag color="blue" v-for="v in tripInfo.customerinfo.memberChildren">{{ v.vip_key }}</a-tag>
            </div>
            <a-tag color="red" v-else>未入会</a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="合计售卖金额(元)">
            <a-statistic :value="price_total_all" class="ml-20" />
          </a-descriptions-item>
          <a-descriptions-item label="实际总利润(元)">
            <a-statistic :value="profit_total_all" class="ml-20" />
          </a-descriptions-item>
          <a-descriptions-item label="总成本(元)">
            <a-statistic :value="cost_total_all" class="ml-20" />
          </a-descriptions-item>
          <a-descriptions-item label="销售">
            {{ tripInfo.customerinfo && tripInfo.customerinfo.managerinfo ?
              tripInfo.customerinfo.managerinfo.user.real_name : '' }}
          </a-descriptions-item>
          <a-descriptions-item label="客户余额(元)">
            <a-tooltip placement="bottom">
              <template slot="title">负数为：需要向客户收款的金额
              </template>
              <a-statistic :value="unpaid_payment" class="ml-20" :suffix="`(现场付款${scene_positive})`" />
              <!-- <a-statistic :value="unpaid_payment" class="ml-20"></a-statistic> -->
            </a-tooltip>
          </a-descriptions-item>
          <a-descriptions-item label="利润额外费用(元)">
            <a-statistic class="ml-20" :value="other_expenses"></a-statistic>
          </a-descriptions-item>
          <a-descriptions-item label="供应商费用(元)">
            <a-statistic class="ml-20" :value="supplier_money" :suffix="`（还应付${supplier_meet}）`"></a-statistic>
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
      <!-- <a-col :span="5">
        <a-descriptions class="mb-20" title="客户信息" :column="1">
          <a-descriptions-item label="客户姓名" :value="tripInfo.customerinfo.customer_name">
            {{ tripInfo.customerinfo.customer_name }}
          </a-descriptions-item>
          <a-descriptions-item label="vip级别" :value="tripInfo.customerinfo.customer_name">
            {{ tripInfo.customerinfo.customer_name }}
          </a-descriptions-item>
        </a-descriptions>
      </a-col> -->
    </a-row>
    <a-tabs v-model="activekey" type="card">
      <a-tab-pane key="1" tab="项目做单">
        <a-row type="flex">
          <a-col>
            <a-form layout="inline" :form="dataForm" class="mb-20">
              <a-form-item label="项目名称">
                <a-input v-model="dataForm.project_name" allowClear placeholder="项目名称" />
              </a-form-item>
              <a-form-item label="是否已发预订单">
                <a-select v-model="dataForm.is_yuding" placeholder="可选择" style="width: 120px;" allowClear>
                  <a-select-option value="1">是</a-select-option>
                  <a-select-option value="2">否</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="是否已给供应商结算">
                <a-select v-model="dataForm.is_jiesuan" placeholder="可选择" style="width: 120px;" allowClear>
                  <a-select-option value="1">是</a-select-option>
                  <a-select-option value="2">否</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item>
                <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
              </a-form-item>
              <a-form-item>
                <a-button type="" @click="sortorder">项目排序</a-button>
              </a-form-item>
              <a-form-item v-permission="['admin:tripproject:create']">
                <a-button type="primary" @click="addOrUpdateHandle()">添加项目</a-button>
              </a-form-item>
              <a-form-item>
                <a-button type="primary" @click="exportProjectlist"
                  v-permission="['admin:tripproject:exportProject']">导出项目清单表</a-button>
              </a-form-item>
              <a-form-item>
                <a-button type="primary" @click="exportProjectmoney"
                  v-permission="['admin:tripproject:exportProjectMoney']">导出项目利润表</a-button>
              </a-form-item>
              <a-form-item>
                <a-button type="danger" :disabled="selectedRowKeys.length == 0"
                  @click="batchJiesuanHandle()">批量供应商结算</a-button>
              </a-form-item>
            </a-form>
          </a-col>
          <!-- <a-col style="display: flex">
        <a-statistic
          title="行程合计总金额"
          :value="price_total_all"
          class="ml-40"
        />
        <a-statistic title="已收款金额" :value="600" class="ml-40" />
      </a-col> -->
        </a-row>
        <a-table bordered :columns="columns" :data-source="dataList" :pagination="false" rowKey="tripproject_id"
          :loading="dataListLoading" :scroll="{ x: 1950 }" :key="tableKey" :expanded-row-keys.sync="expandedRowKeys"
          @expand="expandedOneRow" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }">
          <template slot="project_name" slot-scope="project_name, row">
            {{ project_name }}
            <!-- <div v-if="row.process_status == 1" style="color: grey;font-size: 12px;">收款审核中</div>
            <div v-if="row.process_status == 2" style="color: green;font-size: 12px;">收款审核已通过</div>
            <div v-if="row.process_status == 3" style="color: red;font-size: 12px;white-space: wrap;">收款审核被拒绝（{{
              row.process_reason }}）
            </div> -->
          </template>
          <template slot="tripprojectdaysChildren" slot-scope="tripprojectdaysChildren, row">
            <a-timeline>
              <a-tag v-for="v in tripprojectdaysChildren" :key="v.id" color="green">
                {{ v.day }}
              </a-tag>
            </a-timeline>
          </template>
          <template slot="days" slot-scope="days, row">
            <span v-if="row.days_project == 1">{{ days }}</span>
            {{ row.days_unit }}
            <a-tag class="ml-10" :color="row.days_project == 1 ? 'green' : 'blue'">{{
              row.days_project == 1 ? "参与价格计算" : "不参与价格计算"
            }}</a-tag>
          </template>
          <!-- <template slot="project_remark" slot-scope="project_remark">
            {{ project_remark }}
          </template> -->
          <template slot="price_total" slot-scope="price_total">
            {{ price_total }}
          </template>
          <template slot="editBtn" slot-scope="text, row">
            <!-- <a type="link" class="btn-edit" @click="shoukuan(row.tripproject_id)">
              收款
            </a>
            <a type="link" class="btn-edit" style="padding-left: 10px;" @click="shoukuan(row.tripproject_id)">
              收款审核
            </a>
            <a type="link" class="btn-edit" style="padding-left: 10px;" @click="addOrUpdateHandle(row.tripproject_id)">
              编辑
            </a>
            <a type="link" class="btn-edit" style="padding-left: 10px;" @click="deleteHandle(row.tripproject_id)">
              删除
            </a> -->
            <a-space>
              <a type="link" style="font-weight: bold;" :style="{ color: row.is_jiesuan === '1' ? '#52c41a' : 'red' }"
                @click="jiesuan(row)" v-permission="['admin:tripproject:jiesuan']">{{ row.is_jiesuan === '1' ?
                  '设为未结算' : '设为结算' }}</a>
              <a type="link" @click="addOrUpdateHandle(row.tripproject_id)"
                v-permission="['admin:tripproject:update']">编辑项目</a>
              <a type="link" @click="deleteHandle(row.tripproject_id)"
                v-permission="['admin:tripproject:delete']">删除</a>
              <!-- <a-dropdown size="small"
                v-permission="['admin:tripproject:receivePayment', 'admin:tripproject:receivePaymentExamine', 'admin:tripproject:delete']">
                <a-button icon="more" size="small"></a-button>
                <a-menu slot="overlay" @click="handleMenuClick($event, row.tripproject_id)">
                  <a-menu-item key="1" v-permission="['admin:tripproject:receivePayment']"> <a-icon
                      type="strikethrough" />编辑收款信息 </a-menu-item>
                  <a-menu-item key="2" v-permission="['admin:tripproject:receivePaymentExamine']"> <a-icon
                      type="snippets" />提交收款审核 </a-menu-item>
                  <a-menu-item key="3" v-permission="['admin:tripproject:delete']"> <a-icon type="delete" />删除项目
                  </a-menu-item>
                </a-menu>
              </a-dropdown> -->
            </a-space>


          </template>
          <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
            <a-timeline>
              <a-timeline-item v-for="v in record.tripprojectlogChildren" :key="v.tripprojectlog_id"
                :color="v.log_type == 2 ? 'green' : v.log_type == 3 ? 'blue' : 'red'">{{ v.log_content }}
                <p>{{ v.user.real_name }} {{ v.log_createtime }}</p>
              </a-timeline-item>
            </a-timeline>
          </p>
        </a-table>
      </a-tab-pane>
      <a-tab-pane key="2" tab="项目修改/操作记录合集">
        <log ref="log" :trip_id="dataForm.trip_id"></log>
      </a-tab-pane>
      <a-tab-pane key="3" tab="出行计划">
        <tripdays ref="tripdays" :trip_id="dataForm.trip_id"></tripdays>
      </a-tab-pane>
      <a-tab-pane key="4" tab="出行备注">
        <tripremark ref="tripremark" :trip_id="dataForm.trip_id"></tripremark>
      </a-tab-pane>
      <a-tab-pane key="5" tab="客户余额变更">
        <shoukuanlist key="shoukuanlist1" ref="shoukuanlist" @ok="getDataList" :trip_id="dataForm.trip_id" channel="1">
        </shoukuanlist>
      </a-tab-pane>
      <a-tab-pane key="6" tab="利润额外费用">
        <shoukuanlist key="shoukuanlist2" ref="shoukuanlist" @ok="getDataList" :trip_id="dataForm.trip_id" channel="2">
        </shoukuanlist>
      </a-tab-pane>
      <a-tab-pane key="7" tab="供应商收付款">
        <shoukuanlist key="shoukuanlist3" ref="shoukuanlist" @ok="getDataList" :trip_id="dataForm.trip_id" channel="3">
        </shoukuanlist>
      </a-tab-pane>
      <a-tab-pane key="8" tab="现场收付款">
        <shoukuanlist key="shoukuanlist4" ref="shoukuanlist" @ok="getDataList" :trip_id="dataForm.trip_id" channel="4">
        </shoukuanlist>
      </a-tab-pane>
      <a-tab-pane key="9" tab="客户号码隐私">
        <privacyphone ref="privacyphone" :trip_id="dataForm.trip_id" :sub_id="tripInfo.sub_id"
          :group_id="tripInfo.group_id" @bindok="getTripInfo"></privacyphone>
      </a-tab-pane>
      <a-tab-pane key="10" tab="客户信息备注">
        <remind :trip_id="dataForm.trip_id"></remind>
      </a-tab-pane>
      <!-- <a-tab-pane key="11" tab="行程服务人员配置（新功能）">
        <a-form-model ref="ruleForm" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-model-item ref="name" label="行程服务（配置）人员" prop="partner_userids">
            <a-select show-search :filter-option="filterOption" mode="multiple" v-model="form.partner_userids"
              style="width: 100%" placeholder="请选择人员">
              <a-select-option v-for="v in userList" :key="v.user_id" :value="v.user_id">
                {{ v.real_name }}
              </a-select-option>
            </a-select>
            <p>设置后，会员在小程序中查看行程时，可以点击电话联系上述工作人员</p>
            <a-button type="primary" @click="partnerSubmit" :loading="partnerloading">点击保存</a-button>
          </a-form-model-item>
        </a-form-model>
      </a-tab-pane> -->
    </a-tabs>
    <addorupdate ref="addOrUpdate" @ok="okproject"></addorupdate>
    <payment ref="payment" @ok="okpayment"></payment>
    <shoukuan ref="shoukuan" @ok="getDataList"></shoukuan>
    <addorupdateExtra ref="addorupdateExtra" @ok="getDataList"></addorupdateExtra>
    <Sortorder ref="sortorder" @ok="getDataList"></Sortorder>
    <template slot="footer">
      <a-button type="primary" @click="handleOk">关闭</a-button>
    </template>
  </a-modal>
</template>

<script>
import "element-ui/lib/theme-chalk/index.css";
import viewModule from "@/mixins/view-module";
import addorupdate from "./addorupdate.vue";
import log from "./log.vue";
import payment from "./payment.vue";
import shoukuan from "./shoukuan.vue";
import addorupdateExtra from "./addorupdateExtra.vue";
import tripdays from "./tripdays.vue";
import shoukuanlist from "./shoukuanlist.vue";
import tripremark from './tripremark.vue'
import privacyphone from "./privacyphone.vue";
import Sortorder from "./sortorder.vue";
import remind from "./remind.vue";
export default {
  components: {
    addorupdate,
    log,
    payment,
    shoukuan,
    addorupdateExtra,
    tripdays,
    shoukuanlist,
    tripremark,
    privacyphone,
    Sortorder,
    remind,
  },
  mixins: [viewModule],
  data() {
    return {
      selectedRowKeys: [],
      selectedRows: [],
      form: {
        partner_userids: [],
      },
      partnerloading: false,
      labelCol: {
        span: 4,
      },
      wrapperCol: {
        span: 14,
      },
      userList: [],
      activekey: "1",
      tableKey: new Date().getTime() + '',
      tripInfo: {
        trip_name: "",
        person_length: "",
        trip_days: '',
        trip_createtime: "",
        tripPaymentChildren: [],
        trip_msg: [],
        tripextracostsChildren: [],
        customerinfo: {},
      },
      expandedRowKeys: [],
      visible: false,
      dataForm: {
        trip_id: "", //行程id
        project_name: "",
        is_yuding: undefined,
        is_jiesuan: undefined
      },
      price_total_all: "", //销售总金额
      profit_total_all: "", //总利润金额
      cost_total_all: "", //总成本金额
      unpaid_payment: "",//客户余额
      other_expenses: "",//额外费用
      supplier_money: "",//供应商费用
      supplier_meet: "",//供应商应付费用
      scene_positive: "",//现场付款
      mixinViewModuleOptions: {
        createdIsNeed: false,
        getDataListURL: "/admin/tripproject/page",
        deleteURL: "/admin/tripproject/delete",
      },
      columns: [
        {
          title: "项目名称",
          dataIndex: "project_name",
          scopedSlots: { customRender: "project_name" },
          width: 180,
          ellipsis: true,
        },
        {
          title: "售卖单价(元)",
          dataIndex: "project_price",
          width: 120,
        },
        {
          title: "数量",
          dataIndex: "project_num",
          width: 80,
        },
        {
          title: "计价数量",
          dataIndex: "days",
          scopedSlots: { customRender: "days" },
          width: 120,
        },
        {
          title: "定金(元)",
          dataIndex: "deposit",
          width: 100,
        },
        {
          title: "尾款(元)",
          dataIndex: "arrears",
          width: 100,
        },
        {
          title: "项目当天时间",
          dataIndex: "tripprojectdaysChildren",
          width: 140,
          scopedSlots: { customRender: "tripprojectdaysChildren" },
          // customRender: (text) => text.substr(0, 11)
        },
        {
          title: "项目旁白",
          dataIndex: "project_remark",
          // scopedSlots: { customRender: "project_remark" },
          // customRender: (text) => (text ? text : "无"),
          ellipsis: true,
          width: 200,
        },
        {
          title: "项目备注",
          dataIndex: "project_remark2",
          // scopedSlots: { customRender: "project_remark" },
          // customRender: (text) => (text ? text : "无"),
          ellipsis: true,
          width: 300,
        },
        {
          title: "合计售价",
          dataIndex: "price_total",
          width: 120,
          fixed: "right",
          style: { color: 'red' }
        },
        {
          title: "合计成本",
          dataIndex: "cost_total",
          width: 115,
          fixed: "right",
        },
        // {
        //   title: "额外费用/元",
        //   dataIndex: "totalExtraCosts",
        //   width: 130,
        //   fixed: "right",
        //   scopedSlots: { customRender: "totalExtraCosts" },
        // },
        {
          title: "合计利润",
          dataIndex: "profit_total",
          width: 100,
          fixed: "right",
        },
        {
          title: "操作",
          scopedSlots: { customRender: "editBtn" },
          width: 250,
          fixed: "right",
        },
      ],
    };
  },
  methods: {
    batchJiesuanHandle() {
      this.$refs.shoukuan.init({ trip_id: this.dataForm.trip_id, channel: '3', pay_type: '2', selectedRows: this.selectedRows })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    getUserList() {
      this.$http({
        url: "/admin/user/page?page=1&limit=200",
        method: "get",
      }).then((res) => {
        this.userList = res.data.result;
      });
    },
    //保存行程服务人员
    partnerSubmit() {
      console.log(this.form.partner_userids)
      this.partnerloading = true
      this.$http({
        url: "/admin/trip/triPpartnerSet",
        method: "post",
        data: {
          trip_id: this.dataForm.trip_id,
          partner_userids: this.form.partner_userids.join(","),
        }
      }).then((res) => {
        this.$message.success(res.message);
      }).finally(() => {
        this.partnerloading = false
      })
    },
    init(trip_id) {
      this.dataForm.trip_id = trip_id;
      this.visible = true;
      this.getDataList();
      this.getTripInfo();
      this.getUserList();
    },
    handleMenuClick(e, tripproject_id) {
      if (e.key == '1') {
        //财务收款
        this.shoukuan(tripproject_id)
      }
      if (e.key == '2') {
        //财务收款审核
        this.shoukuanshenhe(tripproject_id)
      }
      if (e.key == '3') {
        //删除
        this.deleteHandle(tripproject_id)
      }
    },
    //订单排序
    sortorder() {
      this.$refs.sortorder.init(this.dataForm.trip_id)
    },
    //添加修改收款成功回调
    okpayment() {
      this.getDataList()
      this.getTripInfo();
    },
    //收付款
    shoukuan(tripproject_id) {
      this.$refs.shoukuan.init(tripproject_id)
    },
    //收款审核
    shoukuanshenhe(tripproject_id) {
      this.$confirm({
        title: '是否将当前项目提交收款审核',
        content: h => <div style="color:red;">请确保项目已收款，下一步进行审核操作</div>,
        onOk: () => {
          this.$http({
            url: '/admin/tripproject/receivePaymentExamine',
            method: 'post',
            data: {
              tripproject_id
            }
          }).then(() => {
            this.$message.success("提交收款审核成功")
            this.getDataList();
          })
        },
      });
    },
    //导出项目列表
    exportProjectlist() {
      this.$http({
        url: '/admin/tripproject/exportProject?trip_id=' + this.dataForm.trip_id,
        method: 'get',
        responseType: 'blob'
      }).then(data => {
        const url = window.URL.createObjectURL(new Blob([data.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `项目清单表.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
    },
    exportProjectmoney() {
      this.$http({
        url: '/admin/tripproject/exportProjectMoney?trip_id=' + this.dataForm.trip_id,
        method: 'get',
        responseType: 'blob'
      }).then(data => {
        const url = window.URL.createObjectURL(new Blob([data.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `项目利润表.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
    },
    //行程详情
    getTripInfo() {
      this.$http({
        url: "/admin/trip/info",
        method: "post",
        data: {
          id: this.dataForm.trip_id,
        },
      }).then((res) => {
        this.tripInfo = {
          ...res.data
        };
        this.form.partner_userids = res.data.partner_userids ? res.data.partner_userids.split(",") : [];
      });
    },
    addOrUpdateHandle(tripproject_id = "") {
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(this.dataForm.trip_id, tripproject_id);
      });
    },
    //直接设置结算
    jiesuan(row) {
      this.$http({
        url: '/admin/tripproject/setjieusan',
        method: 'post',
        data: {
          tripproject_id: row.tripproject_id,
          is_jiesuan: row.is_jiesuan === '1' ? '2' : '1'
        }
      }).then(() => {
        this.$message.success("设置成功")
        this.getDataList()
      })
    },
    //添加收款
    addOrUpdatePaymentHandle(external_id) {
      this.$refs.shoukuan.init({ external_id, trip_id: this.dataForm.trip_id, channel: "1" });
    },
    //删除余额收款
    addOrUpdatePaymentDeleteHandle(payment_id) {
      this.$confirm({
        title: '是否确认删除此客户款项？',
        content: '删除后不可恢复',
        onOk: () => {
          this.$http({
            url: '/admin/tripprojectpayment/delete',
            method: 'post',
            data: { id: payment_id }
          }).then(() => {
            this.$message.success("删除成功")
            this.getTripInfo()
            this.getDataList()
          })
        },
      })
    },
    handleOk() {
      this.visible = false;
      this.expandedRowKeys = [];
    },
    okproject() {
      this.getDataList();
      this.$refs.log.getDataList();
    },
    queryAfter(res) {
      this.price_total_all = res.data.price_total_all;
      this.cost_total_all = res.data.cost_total_all;
      this.profit_total_all = res.data.profit_total_all;
      this.unpaid_payment = res.data.unpaid_payment;
      this.other_expenses = res.data.other_expenses
      this.supplier_money = res.data.supplier_money
      this.supplier_meet = res.data.supplier_meet
      this.scene_positive = res.data.scene_positive
      this.expandedRowKeys = [];
      setTimeout(() => {
        this.tableKey = new Date().getTime() + '2'
      }, 500)
    },
    playExtraCosts(row) {
      this.$refs.addorupdateExtra.init(row)
    },
    //删除额外费
    delExtraCosts(row) {
      this.$confirm({
        title: `是否确认删除额外收款：${row.title}?`,
        content: '删除后将无法恢复',
        onOk: () => {
          this.$http({
            url: '/admin/tripextracosts/delete',
            method: 'post',
            data: {
              id: row.id
            }
          }).then(() => {
            this.$message.success('删除成功')
            this.getDataList()
          })
        },
      });
    },
    expandedOneRow(expanded, record) {
      // 控制只展开一行
      if (expanded) {
        // 展开前先清空，在赋值，只展开一行
        this.expandedRowKeys = [];
        this.expandedRowKeys.push(record.tripproject_id);
      } else {
        this.expandedRowKeys = [];
      }
      this.$nextTick(() => {
        setTimeout(() => {
          const element = document.querySelectorAll(
            `[data-row-key='${record.tripproject_id}-extra-row']`
          );
          // 计算需要展开高度， 采用append dom元素的方式撑开高度，直接修改高度，
          // 但是当前行触发moursemove事件 会触发dom style 重置
          // 33 是td 的 padding 值 加 border值
          const height = element[0].getBoundingClientRect().height - 33;
          element[1].childNodes[0].innerHTML = `<div style="height: ${height}px;"></div>`;
        }, 0);
      });
    },
  },
};
</script>

<style scoped>
.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 12px;
  font-size: 20px;
  color: #999;
  transition: all 0.3s;
}

.dynamic-delete-button:hover {
  color: #777;
}

.dynamic-delete-button[disabled] {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>